import { ContentType } from 'library/ts/model/enums/content/ContentType';
import { PlayerAdapterPlaybackState } from 'library/ts/player/adapter/enums/PlayerAdapterPlaybackState';
import { PlayerAdapterEvent } from 'library/ts/player/adapter/events/PlayerAdapterEvent';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { PageAction } from 'skin/ts/Skin/model/PageAction';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { TagAction } from 'tag/ts/tag/model/enums/TagAction';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { EmbedDeviceVersion } from 'tag/ts/tag/model/type/embed/EmbedDeviceVersion';
import { EmbedPlatform } from 'tag/ts/tag/model/type/embed/EmbedPlatform';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class PublicEnums {
    get TagEvent() {
        return TagEvent;
    }
    get TagAction() {
        return TagAction;
    }
    get PlayerEvent() {
        return PlayerAdapterEvent;
    }
    get Metrics() {
        return Metrics;
    }
    get PlaybackState() {
        return PlayerAdapterPlaybackState;
    }
    get ContentType() {
        return ContentType;
    }
    get EmbedType() {
        return EmbedType;
    }
    get EmbedPlatform() {
        return EmbedPlatform;
    }
    get EmbedDevice() {
        return EmbedDevice;
    }
    get EmbedDeviceVersion() {
        return EmbedDeviceVersion;
    }
    get PageAction() {
        return PageAction;
    }
}
